export default "__VITE_ASSET__6734d353__"